/** Periodos estándar del panel Analytics (días hacia atrás). */
export const ANALYTICS_DAY_OPTIONS = [7, 15, 30, 90, 180] as const;

export type AnalyticsDayOption = (typeof ANALYTICS_DAY_OPTIONS)[number];

/**
 * Aterrizaje / playbooks: la RPC get_early_landing_analytics supera el statement timeout
 * de Postgres por encima de ~60 días en producción.
 */
export const LANDING_ANALYTICS_DAY_OPTIONS = [7, 15, 30, 60] as const;

export type LandingAnalyticsDayOption = (typeof LANDING_ANALYTICS_DAY_OPTIONS)[number];

export const LANDING_ANALYTICS_MAX_DAYS = 60;

export function clampLandingAnalyticsDays(days: number): number {
    return Math.min(Math.max(Math.trunc(days) || 7, 1), LANDING_ANALYTICS_MAX_DAYS);
}

/** Selectores con string + opción Histórico (tendencias, feed, suscripciones…). */
export const ANALYTICS_TIME_RANGES = [
    { value: '7', label: '7 días' },
    { value: '15', label: '15 días' },
    { value: '30', label: '30 días' },
    { value: '90', label: '90 días' },
    { value: '180', label: '180 días' },
    { value: 'all', label: 'Histórico' },
] as const;
